/* global axios */
import ApiClient from './ApiClient';

// Phase 2.9.10 Commit 1: endpoint novo que desacopla modal de disposition
// do CallRecord. Backend aceita `provider_call_id` + dados do SDK e:
//   - se CallRecord ja existe → grava direto (fluxo oficial via
//     DispositionSaveService com todas as side-effects)
//   - se nao → persiste em voip_pending_dispositions. CallRecord.after_create
//     consome o pending quando finalmente nasce do webhook WAHA/VoIP.
class VoipPendingDispositionsAPI extends ApiClient {
  constructor() {
    super('voip_pending_dispositions', { accountScoped: true });
  }

  // payload esperado:
  // {
  //   provider_call_id,              // obrigatorio
  //   peer_phone, peer_name,       // SDK
  //   direction, final_status,     // SDK
  //   duration_seconds,            // SDK
  //   disposition,                 // opcao escolhida ("Agendou Consulta")
  //   notes, next_contact_at,
  //   appointment_date,
  //   lead_temperature,
  //   disposition_custom: { ... }
  // }
  //
  // retorna:
  //   { kind: 'call_record', call_record: {...} }    // caso existente
  //   { kind: 'pending', pending_disposition: {...} } // caso pending
  save(payload) {
    return axios.post(this.url, payload);
  }
}

export default new VoipPendingDispositionsAPI();
